<template>
  <div class="search-menu">
    <div class="search-menu--inner">
      <div class="search-menu--field">
        <input
          ref="searchfield"
          :placeholder="localize('Search')"
          v-model="searchString"
          type="text"
        />
        <transition name="fade-scale" appear>
          <a
            v-if="searchString.length"
            @click="searchString = ''"
            :class="['closebtn', 'btn-white', searching ? ' loading' : '']"
          ></a>
        </transition>
      </div>
      <div
        class="search-menu--history mt-xxl px-xl"
        :class="{
          minimized: !showHistory
        }"
        @[isEvent()]="toggleHistory"
      >
        <i
          @click="toggleHistory"
          :class="[
            'fal',
            !showHistory ? 'fa-plus' : 'fa-times',
            'text-white',
            'hide-history'
          ]"
        ></i>
        <div class="sh search-history--recent mb-xl">
          <i class="fal fa-history mr-xs mt-xs"></i>
          <div class="sh-list">
            <h3 class="font-rg heading__4 text-white">
              <span v-text="localize('recent_searches') + ':'"></span>
            </h3>
            <ul class="no-style" v-if="recentSearches.length">
              <li v-for="item in recentSearches" :key="item.term">
                <a
                  @click.prevent="loadRecentSearch(item)"
                  href="#p"
                  v-text="item.term"
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="sh search-history--popular">
          <i class="fal fa-star mr-xs mt-xs"></i>
          <div class="sh-list">
            <h3 class="font-rg heading__4 text-white">
              <span
                v-if="popularSearches.list"
                v-text="localize('popular searches')"
              ></span>
            </h3>
            <ul class="no-style" v-if="popularSearches.list">
              <li v-for="item in popularSearches.list" :key="item">
                <a
                  @click.prevent="loadPopularSearch(item)"
                  href="#p"
                  v-text="item"
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="results" class="search-menu--results py-2xl">
        <!-- <div v-for="(result, key) in results" :key="key" class="search-result"> -->
        <transition-group
          class="search-result"
          tag="div"
          :css="false"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
          appear
          v-for="(result, key) in results"
          :key="key"
        >
          <h4
            class="search-result__title heading__3 font-rg pb-2xl"
            v-text="key"
            :key="key"
          ></h4>

          <component
            :is="isFile(item.url) ? 'a' : 'router-link'"
            class="search-result--item"
            v-for="(item, index) in result"
            :to="parseLink(item)"
            :href="parseLink(item)"
            :key="index + item.item_id + item.url"
            :target="isFile(item.url) ? '_blank' : '_self'"
            @click.native="toggleOverlay(false)"
          >
            <!-- @[__event(item)].prevent="mediaClickHandler(item.item_id)" -->
            <h5 class="search-result--item--title heading__5 text-blue-2 pb-s">
              <i
                :class="[
                  'fal',
                  isPDF(item.url) ? 'fa-file-pdf' : 'fa-file',
                  'mr-xs'
                ]"
              ></i>
              <span v-text="item.title"></span>
            </h5>
            <h6
              class="text--s text-white pb-s lower"
              v-if="!/prod/i.test(key) && item.url"
            >
              <span v-text="excludeSlash(item.url).split('/')[0]"></span>
              <span
                v-text="
                  '/' + (restOfAddress(excludeSlash(item.url).split('/')) || '')
                "
              ></span>
            </h6>
            <p
              v-if="item.desc && item.desc.length"
              class="search-result--item--desc text-white"
              v-html="item.desc"
            ></p>
          </component>
        </transition-group>
        <!-- </div> -->
      </div>
      <transition name="fade-scale" appear>
        <h2
          v-if="!results && searching"
          class="single-title heading__2 text-white text-center"
          v-html="
            `${localize(
              'search_status'
            )}... <u><strong>${searchString}</strong></u>`
          "
        ></h2>
        <h2
          v-else-if="!results && searchString.length > 1 && searched"
          class="single-title heading__2 text-white text-center"
          v-text="localize('search_no_results')"
        ></h2>
      </transition>
      <button
        v-if="results && hasMore"
        @click="fetchSearch"
        :class="['btn-more block mx-auto', searching ? 'loading' : '']"
      >
        <span v-text="localize('search_load_more')"></span>
        <i
          :class="['fal', searching ? 'fa-spinner' : 'fa-chevron-down ml-xs']"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { storage } from "@/utils";

export default {
  props: ["size"],
  data() {
    return {
      showHistory: true,
      searching: false,
      searched: false,
      searchString: "",
      searchResults: [],
      searchIndex: 0,
      searchCount: 0,
      isRecentSearch: false
    };
  },
  watch: {
    searchString: _.debounce(function() {
      this.searched = false;
      this.searchIndex = 0;
      this.searchCount = 0;
      this.showHistory = false;
      if (this.searchString.length > 1 && !this.isRecentSearch) {
        this.searchResults = [];
        this.fetchSearch();
      } else if (!this.searchString.length) {
        this.searchResults = [];
        this.showHistory = true;
      }
      this.isRecentSearch = false;
    }, 800),
    "results.Media"() {
      console.log("media search results changed...", this.results);
      if (this.results && this.results.Media) {
        this.setGalleryChildren(this.results.Media);
      }
    }
  },
  created() {
    this.initPopularSearches();
    this.initRecentSearches();
  },
  mounted() {
    // console.log("ga >> ", ga);
    this.$nextTick(function() {
      this.$refs.searchfield.focus();
    });
    setTimeout(function() {
      document.body.classList.add("crop");
    }, 500);
  },
  destroyed() {
    document.body.classList.remove("crop");
    console.log("exited search >> ", this.searchResults);

    // storage.set(storageKey, JSON.stringify(json));
  },
  methods: {
    ...mapActions([
      "setGalleryIndex",
      "setGalleryChildren",
      "toggleOverlay",
      "updatePopularSearches",
      "updateRecentSearches"
    ]),
    linkClicked() {
      console.log("LINK CLICKED");
    },
    initRecentSearches() {
      let _r = this.recentSearches;
      console.log("RECENT FROM STORE <", _r);
      /*
        Check localStorage for recent searches
      */
      if (!_r.length) {
        let _s = storage.get("mis_recentSearches", localStorage);
        if (_s) {
          _r = JSON.parse(_s);
        }

        console.log("RECENT FROM STORAGE <", _r);
        this.updateRecentSearches(_r);
      }
    },
    saveToRecentSearches(term, results) {
      let recent = this.recentSearches;
      if (!_.filter(recent, { term }).length) {
        recent.push({ term, results });
      }
      if (recent.length > 5) {
        recent.shift();
      }
      this.updateRecentSearches(recent);
      storage.set("mis_recentSearches", JSON.stringify(recent), localStorage);
    },
    loadRecentSearch(search) {
      this.$set(this, "isRecentSearch", true);
      this.$set(this, "searchString", search.term);
      this.$set(this, "searchResults", search.results);
    },
    loadPopularSearch(search) {
      this.$set(this, "searchString", search);
    },
    initPopularSearches() {
      let _p = this.popularSearches;
      /*
        If popular searches is not populated yet,
        or is older than today, refetch the data.
      */
      if (!_p) {
        let _s = storage.get("mis_popularSearches", localStorage);
        if (_s) {
          _p = JSON.parse(_s);
        }
        this.updatePopularSearches(_p);
      }
      if (!_p || _p.timestamp < new Date()) this.fetchPopularSearches();
    },
    fetchPopularSearches() {
      let vm = this;
      console.log("fetch popularSearches");
      fetch(`https://api.mis-implants.com/api/xStats`, {
        headers: {
          // ln,
          // cc,
          "Content-Type": "application/json"
        },
        method: "get"
        // body // body data type must match "Content-Type" header
      })
        .then(function(response) {
          // console.log('respons >> ', response);
          if (response.status !== 200) {
            throw new Error("Something Went Wrong!");
          }
          return response.json();
        })
        .then(function(json) {
          console.log("POP SEARCH RESPOSNE > ", json);
          if (json && json.search) {
            // pass array of 5 most searched values.
            let timestamp = new Date(),
              list = _.map(_.take(json.search, 5), "val");
            vm.updatePopularSearches({ timestamp, list });
            storage.set(
              "mis_popularSearches",
              JSON.stringify({ timestamp, list }, localStorage)
            );
          }
          return json;
        })
        .catch(function(err) {
          console.log("fetch error >> ", err);
          return err;
        });
      // console.log("popularSearches > ", popularSearches);
    },
    // updateRecentSearches() {},
    /*
      HISTORY > RECENT SEARCHES + POPULAR
    */
    toggleHistory(bool) {
      let _bool = typeof bool === "boolean" ? bool : !this.showHistory;
      this.showHistory = _bool;
    },
    isPDF(url) {
      return /pdf/gi.test(url);
    },
    excludeSlash(url) {
      if (url.indexOf("/") === 0) {
        return url.substr(1);
      }
      return url;
    },
    restOfAddress(urlArr) {
      if (urlArr.length > 2) {
        urlArr.shift();
        return urlArr.join("/");
      } else {
        return urlArr[1];
      }
    },
    fetchSearch: _.debounce(async function() {
      let vm = this;
      let ln, cc;
      ({ ln, cc } = this.locale);
      let _params = {
        Key: this.searchString,
        ShowArchiveRecords: false,
        UseExactPhase: true,
        SearchCatalog: true,
        SearchContent: true,
        SearchMedia: false,
        GetFromIndex: this.searchIndex + this.searchCount,
        GetCount: 6,
        CC: cc,
        LN: ln
      };
      this.searching = true;
      let result = await fetch("https://api.mis-implants.com/api/search", {
        method: "POST",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          cc,
          ln
        },
        referrerPolicy: "no-referrer", // no-referrer, *client
        body: JSON.stringify(_params) // body data type must match "Content-Type" header
      })
        .then(function(response) {
          console.log("1 Search RESPONSE  < ", response);

          return response.json();
        })
        .then(
          async function(json) {
            console.log("response from Search >> ", json);
            if (json.length) {
              /* results exists...
                update recentSearches
                to store && storage
              */
              vm.saveToRecentSearches(vm.searchString, json);
            }
            // window.dataLayer = window.dataLayer || [];

            // >>> For Google Analytics: Save search event
            if (window.dataLayer) {
              window.dataLayer.push({
                event: "global-search",
                searchString: vm.searchString
              });
            }
            // For Google Analytics: Save search event <<<
            return json;
          },
          error => {
            console.log("[fetch|error] register user >> ", error);
            throw new Error(error);
          }
        );
      this.searching = false;
      this.searched = true;
      this.searchCount++;
      if (!this.searchResults.length) {
        this.searchResults = result;
      } else {
        this.searchResults.push(...result);
      }
      this.searchIndex = this.searchIndex + 5;

      console.log("result > ", result);
    }, 300),
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20%)";
    },
    enter: function(el, done) {
      let lapse = 320,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    },
    parseLink(item) {
      if (this.isMedia(item.url)) {
        return "#p";
      } else {
        if (this.isFile(item.url)) {
          if (this.isRelative(item.url)) {
            return `https://www.mis-implants.com/upload/${item.url}`;
          }
        }
      }
      return item.url;
      // this.isMedia(item.url) ? "#p" : item.url;
    },
    mediaClickHandler(item_id) {
      // let id = item.item_id,
      console.log("MEDIA CLICK HANDLER > ", item_id);
      let index = _.findIndex(this.mediaChildren, { item_id });
      this.setGalleryIndex(index);
    },
    isEvent() {
      return !this.showHistory ? "click" : null;
    },
    // __href(item) {
    //   return item.url && !this.isMedia(item.url) ? "href" : "#p";
    // },
    isMedia(url) {
      return url && /(vimeo|youtube)/g.test(url);
    },
    isFile(url) {
      return /\.[0-9a-z]+$/i.test(url);
    },
    isRelative(url) {
      return !/http/.test(url);
    }
  },
  computed: {
    ...mapState({
      mediaChildren: state => state.gallery.children,
      locale: state => state.locale
    }),
    ...mapState(["recentSearches", "popularSearches"]),
    __event() {
      return !this.showHistory ? "click" : null;
    },
    typeMap() {
      let l = this.localize;
      return { 0: l("products"), 1: l("search_content"), 2: "Media" };
    },
    results() {
      if (this.searchResults.length) {
        let grouped = _.groupBy(
          this.searchResults,
          t => this.typeMap[t.item_type]
        );
        if (!this.hasMore) {
          return grouped;
        } else {
          _.each(grouped, v => {
            if (v.length > this.resultCap) {
              v.pop();
            }
          });
          return grouped;
        }
      }
      return null;
    },
    /*  resultCap will give me the amount of items when surpassed means
        more items are available from server.
    */
    resultCap() {
      return this.searchIndex * this.searchCount;
    },
    resultsCounter() {
      if (this.searchResults.length) {
        let types = _.uniqBy(_.map(this.searchResults, "item_type"));
        return types.map(i => _.sumBy(this.searchResults, { item_type: i }));
      }
      return null;
    },
    hasMore() {
      let _hasmore = false;
      if (this.resultsCounter) {
        for (var i = 0; i < this.resultsCounter.length; i++) {
          if (this.resultsCounter[i] > this.resultCap) {
            _hasmore = true;
            break;
          }
        }
      }
      return _hasmore;
    }
  }
};
</script>

<style lang="stylus" scoped>
.search-menu
  _flex(row, wrap, center, center)
  .single-title
    pad('3xl')
    +below(680px)
      padding 60px 10px
  &--history
    _flex(row, wrap, flex-start, space-between)
    position relative
    padding 5% 10%
    margin-left auto
    margin-right auto
    background rgba(#fff, 0.03)
    overflow hidden
    transition max-height 0.3s ease-out-cubic, border-radius 0.3s ease-out-cubic, margin 0.3s ease-out-cubic, width 0.3s ease-out-cubic
    will-change max-height, border-radius, margin, width
    max-height 400px
    border-radius 4px
    width 100%
    &.minimized
      max-height 34px
      padding 0
      margin-top 0px
      margin-bottom 10px
      width 90%
      cursor pointer
      border-radius 0 0 6px 6px
      *:not(i)
        // transition opacity 0.1s ease-out
        opacity 0
    .hide-history
      position absolute
      top 8px
      left 10px
      z-index 99
      cursor pointer
      opacity 0.7
      transition transform 0.3s ease-out-cubic, opacity 0.3s ease-out-cubic
      &.fa-times
        transform rotate(180deg)
      +desktop()
        &:hover
          opacity 1
    .sh
      _flex(row, nowrap, flex-start, flex-start)
      h3
        font-size responsive 18px 30px
        font-range 800px 1900px
        *
          display inline-block
          vertical-align middle
      i
        opacity 0.5
        font-size responsive 16px 30px
        font-range 800px 1900px
        color #fff
      ul li
        margin-top 10px
      a
        color rgba(#fff, 0.8)
        font-size responsive 16px 28px
        font-range 800px 1600px
        font-weight 300 !important
        display block
        &:hover
          color #fff


  &--inner
    padding-top 15vh
    width 90vw
    max-width 1100px
  &--field
    border 4px solid rgba(#fff, 0.8)
    height 90px
    padding 0 45px
    border-radius 45px
    position relative
    _flex(row, nowrap, center, space-between)
    +below(680px)
      height 60px
      border-radius 30px
      padding 0 25px
    input
      width 95%
      background transparent
      border none
      height 70%
      font-size responsive 18px 50px
      font-weight 300 !important
      color #fff
      outline 0
      &:focus
      &:active
        outline 0
      &::placeholder
        color rgba(#fff, 0.3)
  &--results
    _flex(row-reverse, wrap, flex-start, space-between)
    padding-left 45px
    padding-right 45px
    +below(680px)
      _flex(column-reverse, wrap, flex-start, flex-start)
      padding-left 25px
      padding-right 25px
.search-result
  // flex 0 0 calc(50% - 20px)
  &:first-child
    flex none
  &:last-child
    flex 1
    max-width 75%
    padding-right 5%
    +below(1100px)
      max-width 65%

  &:first-child:last-child
    max-width 100%
    padding 0

  margin-bottom 40px
  +below(680px)
    flex 100% !important
    max-width initial !important
    padding 0 !important
    width 100% !important
  &--item
    display block
    margin-bottom 48px
    backface-visibility hidden
    -webkit-appearance none
    transform translateZ(0)
    // p
    //   max-height 60px
    //   overflow hidden
    h5 i
      font-size 85%
    & > *
      opacity 0.88
      filter brightness(100%)
      transition opacity 0.3s ease-out, filter 0.25s ease-out
      will-change opacity, filter
    h6
      // opacity 0.6
      span:last-child
        color rgba(#fff, 0.6)
        transition opacity 0.3s ease-out
    +desktop()
      &:hover > *
        opacity 1
        filter brightness(117%)
        // h6 span
        //   opacity 1
  h4
    color #fff
.btn-more
  position relative
  text-align center
  cursor pointer
  background rgba(blue_2, 0.2)
  height 46px
  padding 0 40px
  border-radius 23px
  color #fff
  transition background 0.3s ease-out
  +desktop()
    &:hover
      background rgba(blue_2, 0.4)
  &.loading
    span
      opacity 0
    i
      position absolute
      top 32%
      left 44%
      font-size 18px
      border 1px solid #fff
      border-top none
      border-right none
      border-radius 50%
      animation spin
      animation-duration 0.33s
      animation-iteration-count infinite
      animation-timing-function ease-out
      animation-direction reverse
      &:before
        opacity 0
</style>
